import React from 'react';
import './ColorDemo.css';

interface ColorScheme {
  name: string;
  description: string;
  primary: string;
  secondary: string;
  accent: string;
  vibe: string;
}

const colorSchemes: ColorScheme[] = [
  {
    name: "Modern Tech",
    description: "Current color scheme",
    primary: "#667eea",
    secondary: "#ff6b35",
    accent: "#4ade80",
    vibe: "Professional, trustworthy, medical/tech"
  },
  {
    name: "Medical Professional",
    description: "Clean and clinical",
    primary: "#0ea5e9",
    secondary: "#10b981",
    accent: "#f59e0b",
    vibe: "Clean, clinical, reliable"
  },
  {
    name: "Biotech Innovation",
    description: "Cutting-edge science",
    primary: "#8b5cf6",
    secondary: "#06b6d4",
    accent: "#84cc16",
    vibe: "Cutting-edge, scientific, innovative"
  },
  {
    name: "Warm Healthcare",
    description: "Approachable and caring",
    primary: "#3b82f6",
    secondary: "#f97316",
    accent: "#22c55e",
    vibe: "Approachable, caring, human-centered"
  },
  {
    name: "Deep Science",
    description: "Research focused",
    primary: "#1e40af",
    secondary: "#dc2626",
    accent: "#059669",
    vibe: "Research-focused, serious, academic"
  },
  {
    name: "Future AI",
    description: "AI-forward design",
    primary: "#6366f1",
    secondary: "#ec4899",
    accent: "#14b8a6",
    vibe: "AI-forward, modern, tech-savvy"
  },
  {
    name: "Minimal Elegance",
    description: "Sophisticated and premium",
    primary: "#374151",
    secondary: "#f59e0b",
    accent: "#6b7280",
    vibe: "Sophisticated, minimal, premium"
  }
];

const ColorDemo: React.FC = () => {
  return (
    <div className="color-demo">
      <header className="demo-header">
        <div className="container">
          <h1>Allegoria Color Scheme Demo</h1>
          <p>Explore different color combinations for the startup homepage</p>
        </div>
      </header>

      <main className="demo-main">
        <div className="container">
          {colorSchemes.map((scheme, index) => (
            <section
              key={index}
              className="color-scheme-section"
              style={{
                '--primary-color': scheme.primary,
                '--secondary-color': scheme.secondary,
                '--accent-color': scheme.accent
              } as React.CSSProperties}
            >
              <div className="scheme-header">
                <h2>{scheme.name}</h2>
                <p className="scheme-description">{scheme.description}</p>
                <p className="scheme-vibe">Vibe: {scheme.vibe}</p>
              </div>

              <div className="color-palette">
                <div className="color-swatch primary">
                  <div className="color-box"></div>
                  <span>Primary: {scheme.primary}</span>
                </div>
                <div className="color-swatch secondary">
                  <div className="color-box"></div>
                  <span>Secondary: {scheme.secondary}</span>
                </div>
                <div className="color-swatch accent">
                  <div className="color-box"></div>
                  <span>Accent: {scheme.accent}</span>
                </div>
              </div>

              <div className="demo-elements">
                <div className="demo-buttons">
                  <button className="primary-demo-btn">Primary Button</button>
                  <button className="secondary-demo-btn">Secondary Button</button>
                  <button className="accent-demo-btn">Accent Button</button>
                </div>

                <div className="demo-card">
                  <h3>AI Cancer Detection</h3>
                  <p>3D structure prediction from 2D images improves accuracy and safety in skin cancer detection compared to 2D AI.</p>
                  <ul className="demo-benefits">
                    <li>✓ Superior accuracy compared to 2D AI systems</li>
                    <li>✓ Works with any smartphone camera</li>
                    <li>✓ Real-world clinical measurements</li>
                  </ul>
                </div>

                <div className="demo-team-card">
                  <div className="team-avatar"></div>
                  <h4>Dr. Sample Name</h4>
                  <p className="team-role">Chief Medical Officer</p>
                  <p className="team-company">Medical Research Institute</p>
                </div>
              </div>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
};

export default ColorDemo;